import { AbsoluteFill, useCurrentFrame, useVideoConfig, interpolate } from "remotion";
import React from "react";

// VFX: Golden Dust Motes
// Category: overlays · Tags: dust, golden, motes, cinematic, brand
export default function FxDustGoldenMotesLoop() {
  const frame = useCurrentFrame();
  const { width, height, durationInFrames } = useVideoConfig();
  const motes = Array.from({ length: 60 }, (_, i) => {
    const seed = i * 91.3;
    const baseX = (Math.sin(seed) * 0.5 + 0.5) * width;
    const baseY = (Math.cos(seed * 1.3) * 0.5 + 0.5) * height;
    const t = (frame + i * 4) / durationInFrames;
    const drift = Math.sin(t * Math.PI * 2 + i) * 60;
    const rise = -((frame * (0.3 + (i % 5) * 0.15)) % (height + 200));
    const size = 2 + (i % 6);
    const twinkle = interpolate(Math.sin(frame * 0.1 + i * 0.5), [-1, 1], [0.25, 1]);
    return {
      x: baseX + drift, y: (baseY + rise + height) % (height + 200) - 50,
      size, opacity: twinkle * 0.85,
    };
  });
  return (
    <AbsoluteFill style={{ background: "transparent" }}>
      {motes.map((m, i) => (
        <div key={i} style={{
          position: "absolute", left: m.x, top: m.y,
          width: m.size, height: m.size, borderRadius: m.size / 2,
          background: "#fbbf24", opacity: m.opacity,
          boxShadow: `0 0 ${m.size * 3}px #fbbf24, 0 0 ${m.size * 6}px rgba(251,191,36,0.4)`,
        }} />
      ))}
    </AbsoluteFill>
  );
}

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
